/* eslint-disable arrow-body-style */
import { API, Auth, Logger } from 'aws-amplify';

const logger = new Logger('ConfirmOrderApiService');
const CONFIRM_ORDER_API_NAME = 'ConfirmOrderApiProxy';

/**
 * Request Options to include authorization headers on all requests
 */
const requestOptions = () => {
  logger.debug('requestOptions..confirmOrders..');
  return Auth.currentAuthenticatedUser()
    .then((user) => {
      return {
        headers: {
            'Content-Type': 'application/json'
        },
      };
    })
    .catch((error) => {
      logger.error('User is not authenticated ', error);
      throw error;
    });
};

/**
 * Request Wrapper to call the request options on all requests
 * @param {*} request
 */
const requestWrapper = (request) => {
  return requestOptions().then((options) => request(options));
};

/**
 * Return a page of vendors
 * this service returns a sorted and filtered list of vendor to make it
 * easier for the client to consume the result
 * @param {*} params
 */
const postPurchaseOrder = (body) => {
  return requestWrapper((options) => {
    // set query params if any
    Object.assign(options, { body });
    // make api request, then filter the result to return only active ones
    return API.post(CONFIRM_ORDER_API_NAME,'', options);
  });
};

export {
    requestWrapper,
    postPurchaseOrder
  };
   
